import React, { ReactNode } from 'react';

import { CheckOutlined, SearchOutlined } from '@ant-design/icons/lib';
import classNames from 'classnames';
import styled from 'styled-components';

import { useSelectAdvancedWithGroupingContext } from './SelectAdvancedWithGroupingContext';
import SelectAdvancedWithGroupingDropdownItemsList from './SelectAdvancedWithGroupingDropdownItemsList';
import Button from '../../components/lib/Button';
import Input from '../../components/lib/Input';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Controls = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 20px 10px 20px;
  gap: 10px;
`;

const Selection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const SelectionActions = styled.div`
  display: flex;
  gap: 10px;

  span {
    color: var(--dark-blue);
    font-size: 12px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    &.disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }
`;

type Props = {
  options: any[];
  otherOptions?: ReactNode;
  selectedItems: any[];
  nonSelectedItems: any[];
  placeholder?: string;
};

const SelectAdvancedWithGroupingDropdown = ({
  options,
  otherOptions,
  selectedItems,
  nonSelectedItems,
  placeholder,
}: Props) => {
  const {
    filteredSelectedItems,
    filteredNonSelectedItems,
    handleSelectItem,
    handleDeselectItem,
    handleSelectAll,
    handleSelectNone,
    handleApplySelection,
    handleSearch,
  } = useSelectAdvancedWithGroupingContext();
  return (
    <Container>
      <Controls>
        <Selection>
          <SelectionActions>
            <span onClick={handleSelectAll} className={classNames({ disabled: nonSelectedItems.length === 0 })}>
              Select All
            </span>
            <span onClick={handleSelectNone} className={classNames({ disabled: selectedItems.length === 0 })}>
              Select None
            </span>
          </SelectionActions>
          <Button type={'primary'} onClick={handleApplySelection} style={{ width: 96, height: 36 }}>
            Apply
          </Button>
        </Selection>
        {options?.length > 6 && (
          <Input
            placeholder={`Search ${placeholder?.toLowerCase() ?? ''}`}
            prefix={<SearchOutlined />}
            onChange={handleSearch}
          />
        )}
      </Controls>
      {otherOptions}
      {filteredSelectedItems.length > 0 && (
        <SelectAdvancedWithGroupingDropdownItemsList
          title={'SELECTED'}
          items={filteredSelectedItems}
          icon={<CheckOutlined size={18} style={{ color: 'var(--positive-green)' }} />}
          onSelect={handleDeselectItem}
          showGroupingDropdown
        />
      )}
      {filteredNonSelectedItems.length > 0 && (
        <SelectAdvancedWithGroupingDropdownItemsList
          title={'NOT SELECTED'}
          items={filteredNonSelectedItems}
          onSelect={handleSelectItem}
        />
      )}
    </Container>
  );
};

export default SelectAdvancedWithGroupingDropdown;
